import type { ChatMessage, OpencodeHistoryItem, OpencodePart } from '../types';

export function sessionTitle(session: { id: string; title?: string; name?: string }): string {
  return session.title || session.name || session.id;
}

export function partsToText(parts?: OpencodePart[]): string {
  return (Array.isArray(parts) ? parts : [])
    .filter(part => part?.type === 'text' && typeof part.text === 'string')
    .map(part => part.text)
    .join('\n\n');
}

export function stripInjectedContext(text: string): string {
  return text.replace(/^## context\s*\n[\s\S]*?\n## end context\s*\n*/i, '').trimStart();
}

export function normalizeHistory(list: OpencodeHistoryItem[]): ChatMessage[] {
  return list
    .map((item, index) => {
      const role = item.info?.role === 'user' ? 'user' as const : 'assistant' as const;
      const content = partsToText(item.parts);
      return {
        id: item.info?.id || `hist-${index}`,
        role,
        content: role === 'user' ? stripInjectedContext(content) : content,
        timestamp: item.info?.time?.created || Date.now(),
      };
    })
    .filter(message => Boolean(message.content));
}
